export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Public Services.d8674db4.png";